module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "1231231231223312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": false,
      "placeInTop": true,
      "appendToBody": true,
      "isCloseOnEsc": true
    },
    on: {
      "close": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent",
      "id": "tasks-create-category"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [(!_vm.theEditCategory) ? [_vm._v("Opret ny kategori")] : [_vm._v("Rediger kategori")]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v("Titel")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    ref: "title_input",
    staticClass: "d-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "keyup": [function($event) {
        _vm.isTitleAlreadyCreated = false
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.createCategory.apply(null, arguments)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isTitleAlreadyCreated) ? _c('p', {
    staticClass: "text--error"
  }, [_vm._v("Titel er allerede brugt")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('div', [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: [{
      'do-bttn--submit--loading': _vm.isSubmitting
    }, {
      'do-bttn--submit--disabled': _vm.title.length < 1
    }],
    on: {
      "click": _vm.createCategory
    }
  }, [_vm._v("\n          Opret\n        ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81db8b00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskOverviewSettings/TaskOverviewSettingsCategoriesCreate.vue
// module id = 1689
// module chunks = 1